// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    RESET_OPEN_PIP_PROGRAMS_REPORT_METRICS: 'RESET_OPEN_PIP_PROGRAMS_REPORT_METRICS',
    RESET_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_CRITERIA: 'RESET_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_CRITERIA',
    SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS: 'SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS',
    SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS_ON_LOAD: 'SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS_ON_LOAD',
    SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_METRICS: 'SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_METRICS',
    SELECT_OPEN_PIP_PROGRAMS_REPORT_METRIC: 'SELECT_OPEN_PIP_PROGRAMS_REPORT_METRIC',
    UPDATE_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTIONS: 'UPDATE_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTIONS',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_DEALER_SELECTION: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_DEALER_SELECTION',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_INCLUDE_FULLY_COMPLETE: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_INCLUDE_FULLY_COMPLETE',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_METRICS: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_METRICS',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_NUMBER: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_NUMBER',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS',
    UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTION: 'UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTION'
});



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/actions-list.js